import { useSearchParams } from "react-router-dom";
import { isStoryblokEditor } from "@utils/storyblokEditor";

/**
 * Returns true when the current page is being rendered inside the Storyblok
 * Visual Editor (detected by the presence of the signed `_storyblok_tk` query
 * params). Editor sessions are validated server-side by the API; this hook only
 * drives editor-specific UI behaviour such as the draft-preview banner and the
 * in-editor draft-failure fallback.
 */
export const useIsStoryblokEditor = (): boolean => {
  const [searchParams] = useSearchParams();
  return isStoryblokEditor(searchParams);
};
